import Helpers from "../../commons/helpers";
import IdentityClient from "./IdentityClient";
import { Constants } from "../../constants/constants";
import { IMultiLanguageContent, IOwnerOrganization, IPagedList } from "../../commons/interfaces";
export interface IReponseCreateOrg {
    organizationId: string
    groupId: string
    ownerName: string
    ownerUserId: string
    ownerEmail: string
    messages: any
    organization: {
        tenantCode: string
        organizationCode: string
        type: number
        name: IMultiLanguageContent
        description: IMultiLanguageContent
        gene: string
        logoId: string
        logoUrl: any
        searchText: string
        id: string
        status: number
        createTime: string
        createUser: string
        updateTime: string
        updateUser: string
    }
};

const OrganizationService = {
    async getAll(data: any) {
        const query = Helpers.handleFormatParams(data);
        const result = await IdentityClient().get(`${Constants.ApiPath.ORGANIZATION.GET_ALL}?${query}`);
        return result.data.result;
    },

    async getPaged(data: any): Promise<IPagedList<any>> {
        const query = Helpers.handleFormatParams(data);
        const result = await IdentityClient().get(`${Constants.ApiPath.ORGANIZATION.GET_PAGED}?${query}`);
        return result.data.result;
    },

    async getDetail(data: { id: string; clientId?: string }) {
        const query = Helpers.handleFormatParams(data);
        const result = await IdentityClient().get(`${Constants.ApiPath.ORGANIZATION.GET_DETAIL}?${query}`);
        return result.data.result;
    },

    async delete(data: any) {
        const result = await IdentityClient().delete(Constants.ApiPath.ORGANIZATION.DELETE, { data });
        return result.data;
    },

    async create(data: any): Promise<IReponseCreateOrg> {
        const result = await IdentityClient().post(Constants.ApiPath.ORGANIZATION.CREATE, data);
        return result.data.result;
    },

    async update(data: any): Promise<string> {
        const result = await IdentityClient().post(Constants.ApiPath.ORGANIZATION.UPDATE, data);
        return result.data.result;
    },

    async updateStatus(data: any) {
        const result = await IdentityClient().post(Constants.ApiPath.ORGANIZATION.UPDATE_STATUS, data);
        return result.data;
    },

    async getOwnedOrganization(query: { exceptCurrentService: boolean }): Promise<IOwnerOrganization[]> {
        const result = await IdentityClient().get(`${Constants.ApiPath.ORGANIZATION.OWNED_ORGANIZATION}?${Helpers.handleFormatParams(query)}`);
        return result.data.result;
    },
};

export default OrganizationService;
